import React, { useState } from "react";
import styles from "../styles/components/VariantGridItem.module.css";
import Loading from "./Loading";
import StatusVariantIndicator from "./StatusVariantIndicator";

const GridItem = ({ variant, index, goToPreview }) => {
  const [imageLoaded, setImageLoaded] = useState(false);

  const handleImageLoad = () => {
    setImageLoaded(true);
  };

  const processing = variant?.character?.processing;
  // console.log(variant)

  return (
    <div
      className={styles.gridItem}
      onClick={() => variant && goToPreview(variant, index)}
    >
      {variant ? (
        <>
          { processing &&
            <Loading messageIndex={1} />
          }
          { (variant.url !== '') &&
            <img
              src={variant.url}
              alt={`Thumbnail ${index}`}
              style={{ display: imageLoaded ? "block" : "none", opacity: processing ? 0.4 : 1 }}
              onLoad={handleImageLoad}
            />
          }
          <StatusVariantIndicator character={variant.character} />
        </>
      ) : (
        <div className={`${styles.placeholder}`}><Loading messageIndex={processing ? 1 : null}/></div>
      )}
    </div>
  );
};

export default GridItem;
